module.exports = __webpack_public_path__ + "static/icon_bausteine1-6d784a5da28eadb0770a86456f363a55.png";